module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAUCAYAAAAQhBSFAAAACXBIWXMAABYlAAAWJQFJUiTwAAABF0lEQVRIic3WvQ3CMBAF4DuJjvSwRbaAPgOwBGIJJFoGiEQb0ZItMgA99KF+yOhS5OT82ZeIJ6WJLfuTHZ/DZBQACRFl8nyIKGfmh8XoJkgAB8ElqultgY1CAtgTkQNuBrpGYYOQE3A6QdhJyAiczpOIrsxcmSENcTqVrGwvthc5I06nF+tFLojT8WJbSACp4NKFcTotLM+Acyd47amZ4VgBXoxwv/Kibp9orAWyJqKCmXPdYIVdxeIEWPs6yPscQCmf0y5kotCVLGRrvbiuANiGYKciS8G9pkyiI9jT2IM6drtNcE1knOPYqjK0kqOurdgMYbuQi+B0um46vd2u1p2XxjWRXzhXZ9tYt5IAbtLwVwGQAbh/AVNkn7u6BUx1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/27.png
// module id = thAT
// module chunks = 1